import ServicesLayout from '@/components/Pages/Services/ServicesLayout';
import Container from '@/components/common/Container';
import Section from '@/components/common/Section';
// import Box from '@/components/common/Box';
import Heading from '@/components/common/Heading';
import PrivacyTerms from '@/components/PrivacyTerms/PrivacyTerms';

import privacyTerms from '@/db/privacy-policy/privacy-policy.json';

const PrivacyPolicy = () => {
  return (
    <>
      <Container>
        <Section>
          <Heading headingLevel="h1" className="mb-12">
            Privacy Policy
          </Heading>
          <PrivacyTerms privacyTerms={privacyTerms} />
        </Section>
      </Container>
    </>
  );
};

PrivacyPolicy.PageLayout = ServicesLayout;

export default PrivacyPolicy;
